import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';

import ProgressBar from './progress-bar';
import CanUser from './can-user';
import MilestoneName from './milestone-name';
import DateTime from 'components/DateTime';

import IconEdit from 'icons/icon-edit';
import IconRoadmap from 'icons/icon-roadmap';
import IconArrowDown from 'icons/icon-arrow-down';
import IconArrowRight from 'icons/icon-arrow-right';

class MilestoneOverviewHead extends PureComponent {
    handleEditClick = () => {
        this.props.onMilestoneClick && this.props.onMilestoneClick(this.props.id);
    }

    handleNameClick = () => {
        this.props.onMilestoneClick && this.props.onMilestoneClick(this.props.id);
    }

    handleToggleClick = () => {
        if (this.props.collapsed) {
            this.props.onExpand(this.props.id);
        } else {
            this.props.onCollapse(this.props.id);
        }
    }

    get duration() {
        return (this.props.duration - 0) + 1;
    }

    render() {
        const { t } = this.props;

        return (
            <div className="overview-main">
                <div className="overview-main-inner">
                    <div className={'overview-main-head' + (this.props.collapsed ? ' collapsed' : '')}>
                        <div className="overview-main-head-inner" onClick={this.handleNameClick}>
                            <span className="overview-main-head-icon">
                                <IconRoadmap />
                            </span>

                            <span className="overview-main-head-text">
                                <MilestoneName id={this.props.id} />
                            </span>
                        </div>

                        <span className="overview-main-head-icon overview-main-head-arrow" onClick={this.handleToggleClick}>
                            {
                                this.props.collapsed ? <IconArrowRight /> : <IconArrowDown />
                            }
                        </span>
                    </div>

                    {
                        !this.props.collapsed ? (
                            <div className="overview-main-body">
                                <ProgressBar progress={this.props.progress} />

                                <p>
                                    <DateTime format="date">{this.props.start}</DateTime>

                                    &nbsp;-&nbsp;

                                    <DateTime format="date">{this.props.end}</DateTime>

                                    <br />

                                    ({ t('durationDays', { count: this.duration }) })
                                </p>

                                <CanUser type="editMilestone">
                                    <div className="overview-main-edit">
                                        <button onClick={this.handleEditClick} className="btn btn-icon"><IconEdit /></button>
                                    </div>
                                </CanUser>
                            </div>
                        ) : null
                    }
                </div>

            </div>
        )
    }
}

export default withTranslation('date')(MilestoneOverviewHead);
